//компонента в которой число плавно увеличивается до заданного
import React, {useEffect, useState} from "react";
import {formatingPrice, isInteger} from "../react/app.cart.lib";

const SpinNumber = ({ val, time, isFormating = false }) => {

    const [ currVal, setCurrVal ] = useState(0);

    let step = 1

    let result = 0;

    if (val) {
        if (currVal !== val) {
            step = getStep(Math.abs(val - currVal));
            if (currVal > val) {
                step *= -1;
            }
        }

        if (isFormating) {
            result = formatingPrice(currVal);
        } else {
            result = currVal;
        }
    }

    let remainder = 0;
    let curRemainder = val - currVal;
    if (curRemainder < 1) {
        remainder = curRemainder;
    }

    useEffect(() => {
        currVal !== val
        && setTimeout(setCurrVal, time, +(currVal + step + remainder).toFixed(2) );
    }, [ currVal, step, val]);

    return <>{result} ₽</>;
}


function getStep(number) {

    let pow = Math.round(Math.log(number) / Math.log(2)) - 1;

    return Math.round(Math.pow(2, pow));
}

export default SpinNumber;
